import React from 'react';
import Icon from '../AppIcon';

// Simple, dependency-free modal â€” no external library assumed. Shows the
// same fields as ProfileCard's body (name, ID, joined date, location) in a
// dedicated "About" view, per the requested feature list. Deliberately
// plain: like ProfileCard, the visual polish/3D treatment is deferred.
const AboutModal = ({ profile, isOpen, onClose }) => {
  if (!isOpen) return null;

  const joinDateLabel = profile?.createdAt?.toDate
    ? profile.createdAt.toDate().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
    : 'Recently';

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4"
      onClick={onClose}
    >
      <div
        className="bg-card border border-border rounded-xl w-full max-w-sm p-6 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition-smooth"
          aria-label="Close"
        >
          <Icon name="X" size={18} />
        </button>

        <h3 className="text-lg font-semibold text-foreground mb-4">About</h3>

        <div className="space-y-3">
          <div className="flex items-center justify-between border-b border-border pb-3">
            <span className="text-sm text-muted-foreground">Full Name</span>
            <span className="text-sm font-semibold text-foreground">{profile?.name}</span>
          </div>
          <div className="flex items-center justify-between border-b border-border pb-3">
            <span className="text-sm text-muted-foreground">Nesolearn ID</span>
            <span className="text-sm font-mono font-semibold text-foreground">{profile?.nesolearnId}</span>
          </div>
          <div className="flex items-center justify-between border-b border-border pb-3">
            <span className="text-sm text-muted-foreground">Date Joined</span>
            <span className="text-sm font-semibold text-foreground">{joinDateLabel}</span>
          </div>
          {profile?.location && (
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Location</span>
              <span className="text-sm font-semibold text-foreground">{profile.location}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AboutModal;